import React from 'react'
import Footer from '../Components/Footer/Footer'
import Header from '../Components/Header/Header'
import MyBookings from '../Components/MyBookings/MyBookings'

const MyBookingsPage = () => {
  return (
    <>
    <Header/>
    <MyBookings/>
 
    </>
  )
}

export default MyBookingsPage